import { Loader, setModuleLoader } from "./platform/_preload";


export function registerDelayed() {
    const _next: {name: string, deps: string[], loader: () => Promise<any>, asyncHint: boolean}[] = [];
    const _waiters: ((loader: Loader) => void)[] = []

    const CatchLoader: Loader = {
        async require(name) { return (async () => {
            const loader = await new Promise<Loader>(rs => _waiters.push(rs));
            return await loader.require(name);
        })() },
        async when_declared(name) {
            const loader = await new Promise<Loader>(rs => _waiters.push(rs));
            return await loader.when_declared(name);
        },
        unload(name) {},
        module(name, deps, loader, asyncHint=false) {
            _next.push({name, deps, loader, asyncHint});
        },
    }
    setModuleLoader(CatchLoader);

    return () => {
        const ModuleLoader = require("@/platform/modules").default;
        setModuleLoader(ModuleLoader);
        const _seen = [..._next];
        _next.length = 0;
        _seen.forEach(({name, deps, loader, asyncHint}) => ModuleLoader.module(name, deps, loader, asyncHint));
        _waiters.forEach((f) => f(ModuleLoader));
        _waiters.length = 0;
    }
}
